// utils/postal.ts (ou en haut du composant)

export const normalizePostal = (raw: string | number): string =>
  String(raw ?? "").replace(/\D/g, ""); // garde uniquement les chiffres

/** Retourne true si 4 ou 5 chiffres ET entre 1000 inclus et 100000 exclu */
export const isValidPostal = (raw: string | number): boolean => {
  const onlyDigits = normalizePostal(raw);
  if (!/^\d{4,5}$/.test(onlyDigits)) return false;
  const n = parseInt(onlyDigits, 10);
  return n >= 1000 && n < 100000;
};